(() => {
  const componentName = 'product-description-accordions';
  const detailsSelector = '[data-auto-description-details]';

  function nodeHasContent(node) {
    if (node.nodeType === 3) return node.textContent.trim().length > 0;
    if (node.nodeType !== 1) return false;
    if (node.textContent.trim().length > 0) return true;

    return Boolean(node.matches('img, video, iframe, table, ul, ol, svg') || node.querySelector('img, video, iframe, table, a[href], ul, ol, svg'));
  }

  function getContentRoot(source) {
    const directHeadings = Array.from(source.children).filter((element) => element.matches('h5'));
    if (directHeadings.length > 0) return source;

    const meaningfulChildren = Array.from(source.childNodes).filter(nodeHasContent);
    if (meaningfulChildren.length !== 1 || meaningfulChildren[0].nodeType !== 1) return source;

    const wrapper = meaningfulChildren[0];
    return Array.from(wrapper.children).some((element) => element.matches('h5')) ? wrapper : source;
  }

  function splitDescription(source, firstTitle) {
    const contentRoot = getContentRoot(source);
    const nodes = Array.from(contentRoot.childNodes);
    const sections = [{ title: firstTitle, nodes: [] }];
    let currentSection = sections[0];
    let foundHeading = false;

    nodes.forEach((node) => {
      if (node.nodeType === 1 && node.matches('h5')) {
        const title = node.textContent.trim();

        if (title) {
          currentSection = { title, nodes: [] };
          sections.push(currentSection);
          foundHeading = true;
        }
        return;
      }

      currentSection.nodes.push(node);
    });

    if (!foundHeading) {
      return [{ title: firstTitle, nodes: Array.from(source.childNodes) }];
    }

    source.replaceChildren();
    return sections.filter((section) => section.title && section.nodes.some(nodeHasContent));
  }

  function configureDetails(details, group) {
    const syncState = () => {
      details.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    };

    details.addEventListener('toggle', () => {
      syncState();
      if (!details.open) return;

      group.querySelectorAll(detailsSelector).forEach((otherDetails) => {
        if (otherDetails !== details) otherDetails.open = false;
      });
    });

    syncState();
  }

  function appendNodes(container, nodes) {
    nodes.forEach((node) => container.appendChild(node));
  }

  class ProductDescriptionAccordions extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      const list = this.querySelector('[data-description-list]');
      const primaryItem = this.querySelector('[data-primary-description-item]');
      const primaryDetails = primaryItem?.querySelector('details');
      const primaryHeading = primaryItem?.querySelector('[data-description-heading]');
      const source = primaryItem?.querySelector('[data-description-source]');
      const template = this.querySelector('template[data-description-template]');

      if (!list || !primaryItem || !primaryDetails || !primaryHeading || !source || !template) return;

      const sections = splitDescription(source, this.dataset.firstTitle || 'Beschreibung');
      if (sections.length === 0) {
        this.remove();
        return;
      }

      primaryHeading.textContent = sections[0].title;
      appendNodes(source, sections[0].nodes);
      primaryDetails.dataset.autoDescriptionDetails = '';
      primaryDetails.open = this.dataset.openFirst === 'true';
      configureDetails(primaryDetails, list);

      sections.slice(1).forEach((section, index) => {
        const item = template.content.firstElementChild.cloneNode(true);
        const details = item.querySelector('details');
        const heading = item.querySelector('[data-description-heading]');
        const content = item.querySelector('[data-description-content]');
        const contentId = `${this.id}-content-${index + 2}`;

        heading.textContent = section.title;
        content.id = contentId;
        details.querySelector('summary').setAttribute('aria-controls', contentId);
        appendNodes(content, section.nodes);
        configureDetails(details, list);
        list.appendChild(item);
      });

      this.dataset.ready = 'true';
    }
  }

  function initializeLegacyMobileDescription(root) {
    if (root.dataset.autoDescriptionReady === 'true') return;

    const originalDetails = root.querySelector(':scope > details');
    const source = originalDetails?.querySelector('.bt-mobile-description-content');
    if (!originalDetails || !source) return;

    const originalSummary = originalDetails.querySelector('summary');
    const firstTitle = originalSummary?.textContent.trim() || 'Beschreibung';
    const sections = splitDescription(source, firstTitle);
    if (sections.length === 0) {
      root.remove();
      return;
    }

    const fragment = document.createDocumentFragment();

    sections.forEach((section, index) => {
      const details = document.createElement('details');
      const summary = document.createElement('summary');
      const content = document.createElement('div');

      details.className = 'bt-mobile-description-details';
      details.dataset.autoDescriptionDetails = '';
      details.open = index === 0 && originalDetails.open;
      summary.textContent = section.title;
      content.className = 'bt-mobile-description-content rte';
      content.dataset.autoDescriptionPanel = '';
      appendNodes(content, section.nodes);
      details.append(summary, content);
      configureDetails(details, root);
      fragment.appendChild(details);
    });

    root.replaceChildren(fragment);
    root.dataset.autoDescriptionReady = 'true';
  }

  function initializeLegacyMobileDescriptions(scope = document) {
    scope.querySelectorAll('.bt-mobile-description-only').forEach(initializeLegacyMobileDescription);
  }

  if (!customElements.get(componentName)) {
    customElements.define(componentName, ProductDescriptionAccordions);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeLegacyMobileDescriptions(), { once: true });
  } else {
    initializeLegacyMobileDescriptions();
  }

  document.addEventListener('shopify:section:load', (event) => initializeLegacyMobileDescriptions(event.target));
})();

